
import LiquidEther from "../reactbits/LiquidEther";
import industryfocus from "../assets/img/home.svg"
import CTA from "./CTA";

import bannerimg from "../assets/img/bannerbg.jpg"




function Banner ({
        title,
        highlight,
        subtitle,
        bgImage,
        primaryBtn,
        secondaryBtn,
        containerWidth = "w-75",
        headingcenter,
    }) {
    return(
        <>

        <section className="bannerimgbox">

  
            <div className="bannerimgboxinner" style={{ backgroundImage: `url(${bgImage})` }}
            >
                <div className="bannerimginnereffect"></div>
                <LiquidEther
                    colors={["#c72430", "#c72430", "#c72430"]}
                    mouseForce={20}
                    cursorSize={100}
                    isViscous={false}
                    viscous={30}
                    iterationsViscous={32}
                    iterationsPoisson={32}
                    resolution={0.5}
                    isBounce={false}
                    autoDemo={true}
                    autoSpeed={0.5}
                    autoIntensity={2.2}
                    takeoverDuration={0.25}
                    autoResumeDelay={3000}
                    autoRampDuration={0.6}
                    style={{ height: "100%" }}
                />
            </div>
                        
            <div className={`bannertextbox ${containerWidth}`}>
            {/* LEFT CONTENT */}
            <div className="bannertextboxcol" data-aos="fade" data-aos-delay="200">

                <div className={`headingbox ${headingcenter} text-center`}>
                    <h1 className="">
                        <span className="uline">
                            <span className=""> {title} </span>
                            {highlight}
                        </span>
                    </h1>
                </div>
    
                <p className="subtextpera">
                {subtitle}
                </p>
    
                {/* BUTTONS */}
                <div className="bannerbtn">
                    {/* <button onClick={() => console.log("Get Started Clicked")} className="bg-[#C72430] cursor-target text-white font-semibold px-8 py-3 rounded-full hover:bg-[#b91c1c] transition">
                        Apply For Membership
                    </button> */}

                    {/* <button onClick={() => console.log("Get Started")} className="border cursor-target border-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-black transition">
                            Contact Us
                        </button> */}

                    {primaryBtn && (

                        <CTA
                            // btnlink="http://wwww.google.com"
                            // btntext="Apply to join the Community"
                            // bgcolor="bg-[#C72430]"  
                            // hoverbgcolor="hover:bg-[#fff] hover:text-[#C72430]"  

                            btnlink={primaryBtn.link}
                            btntext={primaryBtn.text}
                            bgcolor={primaryBtn.bgcolor}
                            hoverbgcolor={primaryBtn.hoverbgcolor}                 
                        />

                        )}

                    {secondaryBtn && (                        

                        <CTA
                            // btnlink="/"
                            // btntext="Connect with us"
                            // bgcolor="bg-[#C72430] border border-white bg-transparent"  
                            // hoverbgcolor="hover:bg-white hover:text-black"       
                            btnlink={secondaryBtn.link}
                            btntext={secondaryBtn.text}
                            bgcolor={secondaryBtn.bgcolor}
                            hoverbgcolor={secondaryBtn.hoverbgcolor}            
                        />
                    )}


                </div>
            </div>
    
            {/* RIGHT IMAGE SECTION */}
            {/* <div className="flex-1 w-full flex justify-center">
                <div className="w-[90%] sm:w-[80%] lg:w-full h-60 sm:h-72 md:h-96" />
                    <img
                    src={industryfocus}
                    data-aos="fade" data-aos-delay="500" data-aos-duration="1000" data-aos-easing="ease-in-out"
                    alt="Create-Surveys-Tailored"             
                    className="rounded-lg w-full h-auto object-cover transition-transform duration-300 ease-in-out hover:translate-y-[-5px]"
                />
                </div> */}
            </div>
        
        </section>

        </>
    )
}

export default Banner;